import {
  Component,
  ElementRef,
  EventEmitter,
  OnChanges,
  Input,
  Output,
  ViewChild,
  AfterContentInit,
  ChangeDetectorRef,
  HostListener
} from '@angular/core';


import { RenderSelectOptionComponent } from './render-select-option/render-select-option.component';


@Component({
  selector: 'render-select',
  templateUrl: 'render-select.component.html',
  styleUrls: ['render-select.component.scss']
})
export class RenderSelectComponent implements OnChanges, AfterContentInit {

  @ViewChild('renderSelectSelector', { static: false }) public renderSelectSelector!: ElementRef;
  @Input() public id!: string;
  @Input() public withFilter: boolean = false;
  @Input() public searchLabel?: string;
  @Input() public value!: string;
  @Input() public defaultValue: string | undefined;
  @Output() public valueChange = new EventEmitter<string>();
  @ViewChild('search', { static: false }) public searchInput: ElementRef | undefined;

  public expanded: boolean = false;
  public image?: string;
  public text?: string;

  private options: RenderSelectOptionComponent[] = [];
  private oldValue?: string;

  constructor(
    private readonly cd: ChangeDetectorRef
  ) {}

  @HostListener('focusout')
  public onFocusOut(): void {
    setTimeout(() => {
      this.expanded = false;
      this.cd.detectChanges();
    }, 200);
  }

  public ngAfterContentInit(): void {
    this.selectCurrentOption();
  }

  public ngOnChanges(): void {
    this.selectCurrentOption();
  }

  public toggle(): void {
    this.expanded = !this.expanded;
    this.cd.detectChanges(); // not required
    if (this.expanded && this.withFilter && this.searchInput) {
      (this.searchInput.nativeElement as HTMLInputElement).focus();
    }
  }

  public filterOptions(event: KeyboardEvent): void {
    const search = (event?.target as HTMLInputElement)?.value;
    this.options.forEach((option: RenderSelectOptionComponent) => {
      const text = option.text.toLowerCase();
      // eslint-disable-next-line no-param-reassign
      (option.el.nativeElement as HTMLOptionElement).style.display = text.indexOf(search) !== -1 ? 'flex' : 'none';
    });
  }

  public optionSelected(image: string, value: string, text: string, event: boolean): void {
    this.image = image;
    this.value = value;
    this.text = text;

    if (value !== this.oldValue) {
      this.oldValue = value;

      if (event) {
        this.valueChange.emit(this.value);
      }
    }
  }

  public addOption(option: RenderSelectOptionComponent): void {
    this.options = this.options.filter((it) => it.value !== option.value);
    this.options.push(option);

    this.selectCurrentOption();
  }

  public setFocus(): void {
    (this.renderSelectSelector.nativeElement as HTMLElement).focus();
  }

  private selectCurrentOption(): void {
    this.options.forEach((option) => {
      if (option.value === this.value) {
        this.optionSelected(option.image, option.value, option.text, false);
      }
    });
  }

}
